import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, filter, take, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import {
  selectSessionAccessReason,
  selectSigning,
} from '../../features/session/store/selectors/session.selectors';
import { SessionAccessReason } from 'src/app/features/session/models/session-access-reason.enum';
import { SessionService } from 'src/app/features/session/services/session.service';

export const signingSessionAccessGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const sessionService = inject(SessionService);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  return store.select(selectSigning).pipe(
    filter((signing) => signing !== null),
    take(1),
    switchMap(() => {
      return store.select(selectSessionAccessReason).pipe(
        take(1),
        switchMap((reason) => {
          if (reason !== SessionAccessReason.Accessible) {
            return of(router.createUrlTree(['/session-inaccessible'], {
              queryParams: { ...route.queryParams, reason },
            }));
          }

          return sessionService.verifySigningSessionCompletion('NoAttestation')
            .pipe(
              map((response) => {
                if (response.isComplete) {
                  return router.createUrlTree(['/session-end']);
                }
                return true;
              })
            );
        })
      );
    })
  );
};
